import { render, staticRenderFns } from "./TaskMixin.vue?vue&type=template&id=6677d7ab"
import script from "./TaskMixin.vue?vue&type=script&lang=ts"
export * from "./TaskMixin.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports